import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Home } from "lucide-react";

export function NotFound() {
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: 'var(--background)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }}>
      <div style={{ textAlign: 'center', padding: '0 16px' }}>
        <div style={{ fontSize: '60px', marginBottom: '16px', fontWeight: 700 }}>
          404
        </div>
        <h2 style={{ marginBottom: '8px', fontSize: '20px', fontWeight: 500, lineHeight: 1.5 }}>
          Страница не найдена
        </h2>
        <p style={{ color: 'var(--muted-foreground)', marginBottom: '24px', fontSize: '14px' }}>
          Запрашиваемая страница не существует
        </p>
        <button
          onClick={() => navigate("/")}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          aria-label="Вернуться на главную страницу"
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            padding: '12px 24px',
            backgroundColor: 'var(--accent)',
            color: 'var(--accent-foreground)',
            borderRadius: '12px',
            border: 'none',
            cursor: 'pointer',
            opacity: isHovered ? 0.9 : 1,
            transition: 'opacity 0.2s ease',
            fontSize: '14px',
            fontWeight: 500,
          }}
        >
          <Home style={{ width: '20px', height: '20px' }} />
          На главную
        </button>
      </div>
    </div>
  );
}
